export const socialsData = {
    github: 'https://github.com/sreerag-rajan',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/genise-butler-6b9721347/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@sreerag.rajan5',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}